import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate, Link } from "react-router-dom";
import { addComment, toggleCommentInteraction, deleteComment, getDataClimats } from "./action";
import { ThumbsUp, ThumbsDown, Trash2, Star, MessageSquare, ArrowLeft, User, X } from "lucide-react";
import "../styles/ajouterCommantaire.css";
import API_BASE_URL from "../config";

export function AjouterCommantaire() {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [Name, setName] = useState("");
    const [Commantaire, setCommantaire] = useState("");
    const [Avis, setAvis] = useState("");
    const [commentError, setCommentError] = useState(false);
    const [ratingError, setRatingError] = useState(false);
    const [shakeComment, setShakeComment] = useState(false);
    const [shakeRating, setShakeRating] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [confirmDeleteInfo, setConfirmDeleteInfo] = useState(null);
    const [deleteError, setDeleteError] = useState('');
    const [isMobile, setIsMobile] = useState(
        window.innerWidth < 901 || (window.innerWidth >= 901 && window.innerWidth <= 1100 && window.innerHeight >= 1000)
    );
    const [showMobileForm, setShowMobileForm] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(
                window.innerWidth < 901 || (window.innerWidth >= 901 && window.innerWidth <= 1100 && window.innerHeight >= 1000)
            );
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const listC = useSelector(s => s.listC);
    const comptes = useSelector(s => s.comptes);
    const Climatisseur = listC.find(a => a.id == id);

    useEffect(() => {
        const loggedUser = localStorage.getItem('user');
        if (loggedUser) {
            const parsedUser = JSON.parse(loggedUser);
            setUser(parsedUser);
            setName(parsedUser.name || (parsedUser.email && parsedUser.email.split('@')[0]) || "Utilisateur");
        }
    }, [navigate]);

    if (!Climatisseur) return null;

    if (!user) {
        return (
            <div className="add-comment-page">
                <div className="comment-page-content" style={{ justifyContent: 'center' }}>
                    <div className="premium-card glass-card" style={{ textAlign: 'center', maxWidth: '500px' }}>
                        <h2><span>Accès Restreint</span>Oops !</h2>
                        <p style={{ marginBottom: '30px', color: '#666' }}>Vous devez être connecté pour partager votre avis.</p>
                        <button className="submit-btn-animated" onClick={() => navigate("/login")}>Se connecter</button>
                        <Link to="/" className="back-link">Retour à l'accueil</Link>
                    </div>
                </div>
            </div>
        );
    }

    const handleLike = async (commentaireId) => {
        const userEmail = user.email;
        await dispatch(toggleCommentInteraction({ id: commentaireId, userEmail, type: 'like' }));
        dispatch(getDataClimats());
    };

    const handleDislike = async (commentaireId) => {
        const userEmail = user.email;
        await dispatch(toggleCommentInteraction({ id: commentaireId, userEmail, type: 'dislike' }));
        dispatch(getDataClimats());
    };

    const handleDelete = (commentaireId) => {
        setConfirmDeleteInfo(commentaireId);
        setDeleteError('');
    };

    const confirmDeleteAction = async () => {
        if (confirmDeleteInfo) {
            setDeleteError('');
            try {
                await dispatch(deleteComment(confirmDeleteInfo)).unwrap();
                dispatch(getDataClimats());
                setConfirmDeleteInfo(null);
            } catch (err) {
                console.error("Failed to delete comment:", err);
                const msg = err?.response?.data?.message || err?.message || "Erreur lors de la suppression.";
                setDeleteError(`Erreur: ${msg}`);
            }
        }
    };

    async function Ajouter(e) {
        e.preventDefault();
        if (isSubmitting) return;

        let isValid = true;

        if (!Commantaire || !Commantaire.trim()) {
            setCommentError(true);
            setShakeComment(true);
            setTimeout(() => setShakeComment(false), 500);
            isValid = false;
        } else {
            setCommentError(false);
        }

        if (!Avis) {
            setRatingError(true);
            setShakeRating(true);
            setTimeout(() => setShakeRating(false), 500);
            isValid = false;
        } else {
            setRatingError(false);
        }

        if (!isValid) return;

        setIsSubmitting(true);
        const newComment = {
            climatiseur_id: parseInt(id),
            username: Name,
            userEmail: user.email,
            commantaire: Commantaire,
            avis: Avis,
            status: 'en attente'
        };

        try {
            await dispatch(addComment(newComment));
            await dispatch(getDataClimats());
            setCommantaire("");
            setAvis("");
            if (isMobile) {
                setShowMobileForm(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setIsSubmitting(false);
        }
    }

    const renderStars = (avis) => {
        const count = parseInt(avis.split(' ')[0]) || 0;
        return (
            <div className="mini-rating">
                {[...Array(5)].map((_, i) => (
                    <Star 
                        key={i} 
                        size={14} 
                        className={i < count ? "mini-star active" : "mini-star"} 
                        fill={i < count ? "#ffc107" : "none"}
                        color={i < count ? "#ffc107" : "#ccc"}
                    />
                ))}
            </div>
        );
    };

    const ratingOptions = [5, 4, 3, 2, 1];

    const renderForm = () => {
        return (
            <form onSubmit={Ajouter} className="form-container-animated" noValidate>
                <div className="premium-form-group">
                    <label>Utilisateur</label>
                    <input
                        type="text"
                        className="premium-input readonly"
                        value={Name}
                        readOnly
                    />
                </div>

                <div className="premium-form-group">
                    <label>Votre commentaire</label>
                    <textarea
                        className={`premium-input ${shakeComment ? 'shake-element' : ''} ${commentError ? 'error-border' : ''}`}
                        placeholder="Dites-nous ce que vous avez pensé..."
                        value={Commantaire}
                        onChange={(e) => {
                            setCommantaire(e.target.value);
                            setCommentError(false);
                        }}
                    ></textarea>
                </div>

                <div className="premium-form-group">
                    <label>Votre note</label>
                    <div className={`star-rating ${shakeRating ? 'shake-element' : ''}`}>
                        {ratingOptions.map((val) => (
                            <React.Fragment key={val}>
                                <input
                                    type="radio"
                                    id={`star${val}`}
                                    name="avis"
                                    value={`${val} ${val === 1 ? 'étoile' : 'étoiles'}`}
                                    className="star-input"
                                    checked={Avis === `${val} ${val === 1 ? 'étoile' : 'étoiles'}`}
                                    onChange={(e) => {
                                        setAvis(e.target.value);
                                        setRatingError(false);
                                    }}
                                />
                                    <label htmlFor={`star${val}`} className="star-label">
                                        <Star 
                                            size={30} 
                                            fill={parseInt(Avis) >= val ? "#ffc107" : "none"} 
                                            color={parseInt(Avis) >= val ? "#ffc107" : (ratingError ? "#ef4444" : "#ccc")} 
                                        />
                                    </label>
                            </React.Fragment>
                        ))}
                    </div>
                </div>

                <button type="submit" className="submit-btn-animated" disabled={isSubmitting}>
                    {isSubmitting ? "Envoi en cours..." : "Envoyer mon avis"}
                </button>
            </form>
        );
    };

    const renderComments = (visibleComments) => {
        return (
            <>
                <div className="list-header">
                    <h3>
                        Avis clients 
                        <span className="count">{visibleComments.length}</span>
                    </h3>
                </div>
                
                <div className="comments-scroll-area">
                    {visibleComments.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                            <p style={{ display: 'block', marginBottom: '10px' }}><MessageSquare size={50} color="#ccc" /></p>
                            <p style={{ color: '#888', fontWeight: '600' }}>
                                Aucun avis pour le moment.
                            </p>
                            <p style={{ color: '#aaa', fontSize: '0.9rem' }}>
                                Soyez le premier à partager votre expérience !
                            </p>
                        </div>
                    ) : (
                        [...visibleComments].sort((a, b) => b.id - a.id).map(c => (
                            <div key={c.id} className={`comment-item ${c.status === 'en attente' ? 'pending-comment' : ''}`} style={c.status === 'en attente' ? { border: '2px dashed #700000', backgroundColor: 'white' } : {}}>
                                <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                                    <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: 'rgba(0,0,0,0.05)', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', flexShrink: 0 }}>
                                        {(() => {
                                            const commentUser = comptes?.find(u => u.username === c.username || (u.email && u.email.split('@')[0] === c.username));
                                            if (commentUser?.image_user) {
                                                return <img src={commentUser.image_user?.startsWith('data:image') ? commentUser.image_user : `${API_BASE_URL.replace('/api', '')}/storage/photos/${commentUser.image_user}`} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />;
                                            }
                                            return (
                                                 <span style={{ fontWeight: '800', fontSize: '1rem', color: 'var(--admin-secondary)', textTransform: 'uppercase' }}>
                                                     {c.username ? c.username.charAt(0) : 'U'}
                                                 </span>
                                             );
                                        })()}
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                                            <h6 style={{ margin: 0, fontSize: '0.95rem' }}>{c.username}</h6>
                                            <div style={{ display: 'flex', gap: '2px' }}>
                                                {[...Array(5)].map((_, i) => (
                                                    <Star
                                                        key={i}
                                                        size={12}
                                                        fill={i < parseInt(c.avis) ? "#ffc107" : "none"}
                                                        color={i < parseInt(c.avis) ? "#ffc107" : "#ccc"}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                        
                                        {c.status === 'en attente' && (
                                            <div style={{ fontSize: '0.75rem', fontWeight: '700', color: '#700000', marginBottom: '8px' }}>En attente de validation</div>
                                        )}
                                        
                                        <p className="item-text" style={{ marginTop: '5px', marginBottom: '10px' }}>{c.commantaire}</p>
                                        
                                        <div className="item-actions">
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <button 
                                                    className={`action-btn ${c.likedBy?.includes(user?.email) ? 'active-like' : ''}`} 
                                                    onClick={() => handleLike(c.id)}
                                                    disabled={c.status === 'en attente'}
                                                    style={c.status === 'en attente' ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                                >
                                                    <ThumbsUp size={16} fill={c.likedBy?.includes(user?.email) ? '#3b82f6' : 'none'} /> <span>{c.like}</span>
                                                </button>
                                                <button 
                                                    className={`action-btn ${c.dislikedBy?.includes(user?.email) ? 'active-dislike' : ''}`} 
                                                    onClick={() => handleDislike(c.id)}
                                                    disabled={c.status === 'en attente'}
                                                    style={c.status === 'en attente' ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                                >
                                                    <ThumbsDown size={16} fill={c.dislikedBy?.includes(user?.email) ? '#ef4444' : 'none'} /> <span>{c.dislike}</span>
                                                </button>
                                            </div>
                                            
                                            {c.username === Name && (
                                                <button 
                                                    className="mini-delete-btn" 
                                                    onClick={() => handleDelete(c.id)} 
                                                    title="Supprimer mon avis"
                                                    style={{ border: 'none', background: 'transparent', padding: '5px' }}
                                                >
                                                    <Trash2 size={16} color="#ef4444" />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </>
        );
    };

    const renderDeleteConfirmationModal = () => {
        return (
            <div onClick={(e) => e.stopPropagation()} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
                <style>{`
                    @keyframes shakeError {
                        0%, 100% { transform: translateX(0); }
                        20%, 60% { transform: translateX(-5px); }
                        40%, 80% { transform: translateX(5px); }
                    }
                `}</style>
                <div style={{ background: 'var(--admin-card-bg, #fff)', borderRadius: '16px', padding: '36px', maxWidth: '420px', width: '90%', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', border: '1px solid var(--admin-border, #eee)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '18px' }}>
                        <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'rgba(239,68,68,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Trash2 size={22} color="#ef4444" />
                        </div>
                        <div>
                            <h3 style={{ margin: 0, fontSize: '1.05rem', color: 'var(--admin-text-main, #333)', fontWeight: 700 }}>Supprimer le commentaire</h3>
                            <p style={{ margin: 0, fontSize: '0.82rem', color: 'var(--admin-text-muted, #666)' }}>Cette action est irréversible.</p>
                        </div>
                    </div>

                    {deleteError && (
                        <div style={{ background: '#fee2e2', color: '#dc2626', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', fontSize: '0.85rem', fontWeight: 600, animation: 'shakeError 0.4s ease-in-out', border: '1px solid #fca5a5' }}>
                            {deleteError}
                        </div>
                    )}

                    <p style={{ fontSize: '0.9rem', color: 'var(--admin-text-main, #333)', marginBottom: '24px', lineHeight: 1.6 }}>
                        Êtes-vous sûr de vouloir supprimer ce commentaire ?
                    </p>
                    <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                        <button onClick={() => { setConfirmDeleteInfo(null); setDeleteError(''); }} style={{ padding: '10px 22px', borderRadius: '8px', border: '1px solid var(--admin-border, #eee)', background: 'transparent', color: 'var(--admin-text-main, #333)', cursor: 'pointer', fontWeight: 600 }}>Annuler</button>
                        <button onClick={confirmDeleteAction} style={{ padding: '10px 22px', borderRadius: '8px', border: 'none', background: '#ef4444', color: '#fff', cursor: 'pointer', fontWeight: 700 }}>Supprimer définitivement</button>
                    </div>
                </div>
            </div>
        );
    };

    const visibleComments = (Climatisseur.commantaires || []).filter(c => 
        c.status === 'validé' || (user && c.userEmail === user.email)
    );

    if (isMobile) {
        return (
            <div className="add-comment-page mobile-layout">
                <button className="mobile-circle-back-btn" onClick={() => navigate(-1)} aria-label="Retour">
                    <ArrowLeft size={20} />
                </button>

                <div className="comment-page-content-mobile">
                    <div className="mobile-card">
                        <div className="form-header mobile-form-header">
                            <span>Partagez votre avis</span>
                            <h2>Donnez votre avis</h2>
                        </div>

                        <div className="mobile-reviews-container">
                            <div className="mobile-reviews-header-block">
                                <div className="pane-right mobile-pane-right">
                                    <div className="list-header">
                                        <h3>
                                            Avis clients 
                                            <span className="count">{visibleComments.length}</span>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <div className="mobile-reviews-list-block">
                                <div className="pane-right mobile-pane-right">
                                    <div className="comments-scroll-area">
                                        {visibleComments.length === 0 ? (
                                            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                                                <p style={{ display: 'block', marginBottom: '10px' }}><MessageSquare size={40} color="#ccc" /></p>
                                                <p style={{ color: '#888', fontWeight: '600', fontSize: '0.9rem' }}>
                                                    Aucun avis pour le moment.
                                                </p>
                                                <p style={{ color: '#aaa', fontSize: '0.8rem' }}>
                                                    Soyez le premier à partager votre expérience !
                                                </p>
                                            </div>
                                        ) : (
                                            [...visibleComments].sort((a, b) => b.id - a.id).map(c => (
                                                <div key={c.id} className={`comment-item ${c.status === 'en attente' ? 'pending-comment' : ''}`} style={c.status === 'en attente' ? { border: '2px dashed #700000', backgroundColor: 'white' } : {}}>
                                                    <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                                                        <div className="mobile-avatar-container">
                                                            {(() => {
                                                                const commentUser = comptes?.find(u => u.username === c.username || (u.email && u.email.split('@')[0] === c.username));
                                                                if (commentUser?.image_user) {
                                                                    return <img src={commentUser.image_user?.startsWith('data:image') ? commentUser.image_user : `${API_BASE_URL.replace('/api', '')}/storage/photos/${commentUser.image_user}`} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />;
                                                                }
                                                                return (
                                                                     <span className="mobile-avatar-initial">
                                                                         {c.username ? c.username.charAt(0) : 'U'}
                                                                     </span>
                                                                 );
                                                            })()}
                                                        </div>
                                                        <div style={{ flex: 1 }}>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '3px' }}>
                                                                <h6 style={{ margin: 0, fontSize: '0.85rem' }}>{c.username}</h6>
                                                                <div style={{ display: 'flex', gap: '2px' }}>
                                                                    {[...Array(5)].map((_, i) => (
                                                                        <Star
                                                                            key={i}
                                                                            size={10}
                                                                            fill={i < parseInt(c.avis) ? "#ffc107" : "none"}
                                                                            color={i < parseInt(c.avis) ? "#ffc107" : "#ccc"}
                                                                        />
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            
                                                            {c.status === 'en attente' && (
                                                                <div style={{ fontSize: '0.7rem', fontWeight: '700', color: '#700000', marginBottom: '5px' }}>En attente de validation</div>
                                                            )}
                                                            
                                                            <p className="item-text" style={{ marginTop: '3px', marginBottom: '8px', fontSize: '0.8rem', lineHeight: '1.4' }}>{c.commantaire}</p>
                                                            
                                                            <div className="item-actions">
                                                                <div style={{ display: 'flex', gap: '8px' }}>
                                                                    <button 
                                                                        className={`action-btn ${c.likedBy?.includes(user?.email) ? 'active-like' : ''}`} 
                                                                        onClick={() => handleLike(c.id)}
                                                                        disabled={c.status === 'en attente'}
                                                                        style={c.status === 'en attente' ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                                                    >
                                                                        <ThumbsUp size={12} fill={c.likedBy?.includes(user?.email) ? '#3b82f6' : 'none'} /> <span style={{ fontSize: '0.75rem' }}>{c.like}</span>
                                                                    </button>
                                                                    <button 
                                                                        className={`action-btn ${c.dislikedBy?.includes(user?.email) ? 'active-dislike' : ''}`} 
                                                                        onClick={() => handleDislike(c.id)}
                                                                        disabled={c.status === 'en attente'}
                                                                        style={c.status === 'en attente' ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                                                    >
                                                                        <ThumbsDown size={12} fill={c.dislikedBy?.includes(user?.email) ? '#ef4444' : 'none'} /> <span style={{ fontSize: '0.75rem' }}>{c.dislike}</span>
                                                                    </button>
                                                                </div>
                                                                
                                                                {c.username === Name && (
                                                                    <button 
                                                                        className="mini-delete-btn" 
                                                                        onClick={() => handleDelete(c.id)} 
                                                                        title="Supprimer mon avis"
                                                                        style={{ border: 'none', background: 'transparent', padding: '3px', marginLeft: 'auto' }}
                                                                    >
                                                                        <Trash2 size={14} color="#ef4444" />
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="mobile-bottom-bar">
                    <button className="mobile-add-btn" onClick={() => setShowMobileForm(true)}>
                        <MessageSquare size={20} style={{ marginRight: '8px' }} />
                        <span>Ajouter un commentaire</span>
                    </button>
                </div>

                {/* Mobile Form Sheet Overlay */}
                {showMobileForm && (
                    <div className="mobile-form-overlay" onClick={() => setShowMobileForm(false)}>
                        <div className="mobile-form-sheet" onClick={(e) => e.stopPropagation()}>
                            <div className="sheet-header">
                                <h3>Donner votre avis</h3>
                                <button className="close-sheet-btn" onClick={() => setShowMobileForm(false)}>
                                    <X size={20} />
                                </button>
                            </div>
                            <div className="sheet-body">
                                {renderForm()}
                            </div>
                        </div>
                    </div>
                )}

                {/* Confirmation Delete Modal */}
                {confirmDeleteInfo && renderDeleteConfirmationModal()}
            </div>
        );
    }

    return (
        <div className="add-comment-page">
            
            <div className="comment-page-content">
                <div className="dual-pane-card">
                    {/* Left Pane: Form (Sticky) */}
                    <div className="pane-left sticky-pane">
                        <div className="form-header">
                            <span>Partagez votre avis</span>
                            <h2>Donnez votre avis</h2>
                        </div>
                        
                        {renderForm()}

                        <button className="back-link" onClick={() => navigate(-1)} style={{background:'none', border:'none', cursor:'pointer', width:'100%', display:'flex', alignItems:'center', justifyContent:'center', gap:'8px', marginTop:'10px', marginBottom: '10px'}}>
                            <ArrowLeft size={18} /> Annuler et Retour
                        </button>
                    </div>

                    {/* Vertical Line */}
                    <div className="vertical-divider"></div>

                    {/* Right Pane: Comments List */}
                    <div className="pane-right">
                        {renderComments(visibleComments)}
                    </div>
                </div>
            </div>

            {/* Confirmation Delete Modal */}
            {confirmDeleteInfo && renderDeleteConfirmationModal()}
        </div>
    );
}